import axios from "axios";
import { serviceDmpToDmp } from "../../../models/dataManagementPlatform";
import { parseNewNewYorkApiResponse } from "../../../utils";
import { NotImplementedError } from "../../../errors";
import { PromiseHandler } from "../../../handlers";
import { parseIdFilter } from "../../../handlers/filter";
import { OrganizationDmpsFetchFailed } from "./errors";
/**
 * Class for handling Data Management Platforms specific to an organization.
 */
class OrganizationDmpsHandler extends PromiseHandler {
    constructor(sdk) {
        // Set a 5-minute TTL (300000 milliseconds)
        super(sdk, "orgDmps", { ttl: 300000 });
        /**
         * Converts a ServiceDataManagementPlatform (BE) -> DataManagementPlatform (FE)
         * @param dmp a dmp from the BE service
         * @return the transformed dmp formatted for FE components
         */
        this.toDmp = (dmp) => {
            return serviceDmpToDmp(dmp);
        };
    }
    /**
     * Fetches DMPs for a specific organization
     * @param orgId The organization ID to get DMPs for
     * @returns Promise resolving to an array of DataManagementPlatform objects
     */
    getOrganizationDMPs(orgId) {
        const url = `${this.sdk.urls.baseAPIUrl}/organization/${orgId}/dmps`;
        // Check cache first
        if (this.cache.has(url)) {
            return this.cache.get(url);
        }
        const config = {
            headers: {
                "Content-Type": "application/json"
            }
        };
        const req = new Promise((resolve, reject) => {
            axios
                .get(url, config)
                .then((res) => {
                try {
                    const { data: serviceDmps } = parseNewNewYorkApiResponse(res);
                    const dmps = serviceDmps.map(this.toDmp);
                    resolve(dmps);
                }
                catch (error) {
                    reject(new OrganizationDmpsFetchFailed(orgId, error));
                }
            })
                .catch((error) => {
                reject(new OrganizationDmpsFetchFailed(orgId, error));
            });
        });
        // Set cache
        this.cache.set(url, req);
        return req;
    }
    /**
     * Handles finding all DMPs for a specific organization
     * @param filters The filters to apply to the find request
     */
    async findItems(filters) {
        // Extract the organization ID from the filters using parseIdFilter
        const idFilter = parseIdFilter(filters);
        // If there's exactly one ID in the filter, use it to fetch DMPs for that organization
        if (idFilter.size === 1) {
            const orgId = idFilter.values().next().value;
            return this.getOrganizationDMPs(orgId.toString());
        }
        // If no organization ID was found, return an empty array
        return Promise.resolve([]);
    }
    /**
     * NOT IMPLEMENTED - base class requires an implementation
     */
    async saveItem(_data) {
        throw new NotImplementedError("save");
    }
    /**
     * NOT IMPLEMENTED - base class requires an implementation
     */
    async deleteItem(_id) {
        throw new NotImplementedError("delete");
    }
    /**
     * Invalidates the cache for a specific organization's DMPs
     * @param orgId The organization ID to invalidate cache for
     */
    invalidateOrgDmpsCache(orgId) {
        const cacheKey = `${this.sdk.urls.baseAPIUrl}/organization/${orgId}/dmps`;
        if (this.cache.has(cacheKey)) {
            this.cache.remove(cacheKey);
        }
    }
}
export default OrganizationDmpsHandler;
//# sourceMappingURL=index.js.map